export default {
  BusinessPurchaseComponentsCom: {
    PO: {
      title: '关联采购单',
      selectPurchase: '选择关联采购单',
      noPurchase: '无采购单',
      code: '采购单号',
      typeMeaning: '采购类型',
      statusMeaning: '订单状态',
      stockinStatusMeaning: '入库状态',
      supplierName: '供应商',
      warehouseName: '收货仓库',
      planQty: '采购数量',
      amount: '采购总金额',
      alreadyQty: '入库数量',
      cancelQty: '停止等待数量',
      buyerName: '采购员',
      loosDate: '开船时间'
    },

    baseMsg: {
      title: '基础信息',
      oddNumber: '单号',
      automatic: '自动生成',
      type: '类型',
      warehouse: '仓库',
      supplier: '供应商',
      logisticsBusiness: '物流公司',
      logisticsNo: '物流单号',
      recipientName: '收件人',
      recipientPhone: '收货人手机',
      recipientAddress: '收货地址',
      detailAddress: '详细地址',
    },

    commodityMsg: {
      title: '商品信息',
      add: '添加',
      commodity: '商品',
      spuPic: '商品图片',
      // spuCode: '商品编码',
      // spuName: '商品名称',
      skuCode: 'SKU编码',
      skuName: 'SKU名称',
      planQtyLabel1: '单据',
      planQtyLabel2: '退货',
      planQtyLabel3: '数量',
      planQty: '单据数量',
      taxUnitPrice: '含税下单价',
      noTaxUnitPrice: '不含税采购价',
      taxRate: '税率',
      taxPrice: '含税金额',
      supplierSpuCode: '供应商商品编码',
      supplierSkuCode: '供应商SKU编码',
    },

    rules: {
      type: '请选择入库类型',
      warehouseCode: '请选择收货仓库',
      supplierCode: '请选择供应商',
      logisticsBusinessId: '请选择物流公司',
      planQty: '请输入单据数量',
      taxUnitPrice: '请输入含税下单价',
      taxRate: '请输入税率'
    },

    bjDialogText: '请选择关联采购单',
    purchaseCode: '关联采购单号',
    choosePurchase: '选择采购',
    commodity: '商品',
    skuCode: 'SKU编码',
    skuName: 'SKU名称',
    planQty: '采购数量',
    waitQty: '未入库数量',
    taxUnitPrice: '含税价',
    taxRate: '税率',
    supplierSpuCode: '供应商商品编码',
    msgError: '请选择入库商品',
    storage: '入库',
    returnGoods: '退货',
    outWarehouse: '出库',
    msgError1: '选择的供应商不一致，请重新选择！',
    msgError2: '此采购单无商品,请选择其他采购单！',
    invoiceNo: '发票号/INV No',
    onPackUpBtn: '收起空项',
    onSpreadBtn: '展开空项',
    alreadyQty: '采购入库数量',
    allPlanQty: '采购总量',
    RecoveryStatus:'补收状态',
    Recovered:'已补收',
    NotRecovered:'未补收',
    Profit:'利润率 (%)',
    amount:'补收金额 (AUD)',
  }
};
